import { jsx as t, jsxs as m } from "react/jsx-runtime";
import { u as n } from "./index-6a632112.mjs";
import { r as a, s as o, b as c, f as v, a as w, l as I } from "./themes-5f0b3c3d.mjs";
import { l as C } from "./lineHeights-72d3110c.mjs";
import f, { useState as g, useRef as $, useEffect as b } from "react";
import { S as L } from "./moreVertical-dc2e97a2.mjs";
import { z as R } from "./zIndices-d07533f3.mjs";
import { f as S } from "./fontWeights-a25f8f91.mjs";
import "./types-b577bf77.mjs";
const z = n.li`
  border-radius: ${a["2x"]};
  background-color: ${(e) => e.theme.components.menu.listItemBackgroundColor};
  min-height: 24px;
  margin-left: -40px;
  padding: ${o["2x"]} ${o["3x"]} ${o["2x"]} ${o["3x"]};

  &:hover:not([disabled]) {
    background-color: ${(e) => e.theme.components.menu.listItemHoverColor};
  }

  &:focus-visible:not([disabled]) {
    outline: ${c["2x"]} solid
      ${(e) => e.theme.components.menu.focusColor};
    border-radius: ${a["2x"]};
  }
`, A = n.button`
  all: unset;
  width: 230px;
  display: flex;
  word-wrap: break-word;
  cursor: ${({ disabled: e }) => e ? "auto" : "pointer"};
  justify-content: ${({ trailingIcon: e }) => e && "space-between"};
  color: ${({ disabled: e, theme: i }) => e ? i.components.menu.textColorDisabled : i.components.menu.textColor};
  font-family: ${v.inter};
  font-size: ${w.small};
  letter-spacing: ${I[0]};
  line-height: ${C.medium};
`, _ = n.div`
  display: flex;
  align-items: center;
  margin-right: ${o["2x"]};
  color: ${(e) => e.theme.components.menu.textColor};

  svg,
  img {
    width: ${o["4x"]};
    height: ${o["4x"]};
`, j = n.div`
  display: inline;
  float: right;
  color: ${(e) => e.theme.components.menu.textColor};

  svg,
  img {
    width: ${o["4x"]};
    height: ${o["4x"]};
`, re = ({
  onClick: e,
  children: i,
  leadingIcon: p,
  trailingIcon: r,
  disabled: s = !1
}) => /* @__PURE__ */ t(
  z,
  {
    disabled: s,
    tabIndex: s ? 1 : 0,
    onKeyDown: (l) => {
      (l.code === "Space" || l.code === "Enter") && e && e();
    },
    children: /* @__PURE__ */ m(
      A,
      {
        tabIndex: -1,
        disabled: s,
        onClick: e,
        trailingIcon: r,
        children: [
          p && /* @__PURE__ */ t(_, { children: p }),
          i,
          r && /* @__PURE__ */ t(j, { children: r })
        ]
      }
    )
  }
), H = n.button`
  height: ${o["10x"]};
  width: ${o["10x"]};
  border-radius: ${a["2x"]};
  &:hover {
    background-color: ${(e) => e.theme.components.menu.ellipsesBackgroundColor};
  }
  background-color: ${(e) => e.$active ? e.theme.components.menu.ellipsesBackgroundColor : "transparent"};

  color: ${(e) => e.theme.components.menu.ellipsesColor};
  border-color: transparent;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;

  &:focus-visible {
    ${(e) => `
          outline: ${c["2x"]} solid
              ${e.theme.components.menu.focusRingColor};
          border-radius: ${a["2x"]};
          padding: 2px;
          outline-offset:2px;
        `}
  }
`, D = ({ active: e, ...i }) => /* @__PURE__ */ t(H, { $active: e, ...i, children: /* @__PURE__ */ t(L, { width: o["4x"], height: o["4x"] }) }), O = "Escape", F = "-234px", G = n.div`
  display: inline-flex;
  justify-content: flex-end;
  position: relative;
`, K = n.div`
  margin-bottom: ${o["1x"]};
  display: flex;
  justify-content: flex-end;
  // &:focus-visible:not([disabled]) {
  //   outline-offset: ${o["1x"]};
  //   outline: 2px solid ${(e) => e.theme.components.menu.focusColor};
  //   border-radius: 80px;
  // }
`, B = n.div`
  display: ${({ $menuOpen: e }) => e ? "block" : "none"};
  position: absolute;
  z-index: ${R.dropdown};
  box-sizing: border-box;
  min-height: 176px;
  width: 270px;
  border: ${c["1x"]} solid
    ${(e) => e.theme.components.menu.borderColor};
  border-radius: ${a["3x"]};
  background-color: ${(e) => e.theme.components.menu.backgroundColor};
  box-shadow: 0 ${c["4x"]} ${c["8x"]} 0 rgba(0, 0, 0, 0.06);
  top: ${o["11x"]};
  right: ${({ $leftAligned: e }) => e ? F : "0"};
`, N = n.ul`
  list-style: none;
  margin: ${o["2x"]};
`, ie = ({
  menuButton: e,
  children: i,
  uniqueIdentifier: p
}) => {
  const [r, s] = g(!1), l = $(null), x = $(null), [y, h] = g(!1);
  e || (e = /* @__PURE__ */ t(D, { active: r }));
  const k = () => {
    r ? u() : W();
  }, E = (d) => {
    switch (d.key) {
      case O:
        u();
        break;
      default:
        return;
    }
  }, M = f.cloneElement(e, {
    onKeyUp: E,
    onClick: k
  }), W = () => {
    s(!0);
  }, u = f.useCallback(() => {
    s(!1);
  }, []);
  return b(() => {
    x.current && (x.current.getBoundingClientRect().x < 0 ? h(!0) : h(!1));
  }, [r]), b(() => {
    const d = (T) => {
      l.current && !l.current.contains(T.target) && r && u();
    };
    return window.addEventListener("click", d), () => {
      window.removeEventListener("click", d);
    };
  }, [r, u]), /* @__PURE__ */ m(G, { ref: l, children: [
    /* @__PURE__ */ t(K, { children: M }),
    /* @__PURE__ */ t(
      B,
      {
        $menuOpen: r,
        id: p,
        role: "menu",
        "aria-hidden": !r,
        ref: x,
        $leftAligned: y,
        children: /* @__PURE__ */ t(N, { children: i })
      }
    )
  ] });
}, P = n.div`
  box-sizing: border-box;
  height: 1px;
  width: 268px;
  border: ${c["1x"]} solid
    ${(e) => e.theme.components.menu.dividerColor};
  margin: ${o["2x"]} 0px ${o["2x"]} -48px;
`, se = () => /* @__PURE__ */ t(P, {}), U = n.div`
  height: 20px;
  width: 59px;
  color: ${(e) => e.theme.components.menu.groupTitleColor};
  font-family: ${v.inter};
  font-size: ${w.xxsmall};
  font-weight: ${S.body.semibold};
  letter-spacing: 1px;
  line-height: ${C.small};
  padding: ${o["2x"]} ${o["3x"]} ${o["2x"]} ${o["3x"]};
  margin-left: -40px;
`, le = ({
  title: e
}) => /* @__PURE__ */ t(U, { children: e }), Y = n.svg`
  cursor: pointer;
`, V = n.button`
  cursor: pointer;
  display: flex;
  align-items: center;
  border: none;
  background-color: transparent;
  color: currentColor;
  padding: 0
`, ce = ({ src: e, ...i }) => /* @__PURE__ */ t(V, { ...i, children: /* @__PURE__ */ m(Y, { height: "40", width: "40", children: [
  /* @__PURE__ */ t("circle", { id: "circle", cx: 20, cy: 20, r: 20 }),
  /* @__PURE__ */ t("clipPath", { id: "circle-clip", children: /* @__PURE__ */ t("use", { xlinkHref: "#circle" }) }),
  /* @__PURE__ */ m("g", { clipPath: "url(#circle-clip)", children: [
    /* @__PURE__ */ t(
      "image",
      {
        xlinkHref: e,
        width: "100%",
        height: "100%",
        preserveAspectRatio: "xMidYMid slice"
      }
    ),
    /* @__PURE__ */ t("use", { xlinkHref: "#circle", fill: "none", opacity: "0.25" })
  ] })
] }) });
export {
  ce as Avatar,
  D as Ellipses,
  ie as Menu,
  se as MenuDivider,
  le as MenuGroupTitle,
  re as MenuItem
};
